// @ts-nocheck
import './index.css';
import './stylesheets/openreplay-debug.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import * as Sentry from '@sentry/react';

import { envInfo, SENTRY_DSN } from '@constants/constants';
import { initializeOpenReplay } from '@utils/openreplay';

import App from './App';

const sentryDsn = envInfo.sentry_enabled ? SENTRY_DSN : undefined;
Sentry.init({
  dsn: sentryDsn,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', envInfo.baseurl],
  environment: envInfo.keycloak_realm,
  sendDefaultPii: false,
  release: process.env.VITE_VERCEL_GIT_COMMIT_SHA,
  // Session replays are disabled here; we rely on OpenReplay for general
  // session reviewability. Sentry replays are only captured when an error
  // occurs (see replaysOnErrorSampleRate below).
  replaysSessionSampleRate: 0,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
});

// Initialize OpenReplay tracker
initializeOpenReplay();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
);
